<div class="container actionsTop col-12">
  <div class="btns-actions">
    <button pButton type="button" (click)="showModalFiltros = true" class="btn-filter">
      <i class="pi pi-search"></i>
      Filtros
    </button>

    <div *ngIf="totalDocumentos > 0">
      <button
        type="button"
        class="btn-exportar pdf"
        [disabled]="exportandoPdf"
        (click)="downloadPdf()">
        <i class="pi" [ngClass]="exportandoPdf ? 'pi-spin pi-spinner' : 'pi-file-pdf'"></i>
        Exportar Relatório PDF
      </button>

      <button
        type="button"
        class="btn-exportar word"
        [disabled]="exportandoWord"
        (click)="downloadWord()">
        <i class="pi" [ngClass]="exportandoWord ? 'pi-spin pi-spinner' : 'pi-file-word'"></i>
        Exportar Word
      </button>
    </div>
  </div>

  <div class="data-filter mt-3" *ngIf="totalDocumentos > 0">
    <div class="flex justify-content-between align-items-center w-full">
      <span class="fw-bold">
        {{ totalDocumentos }} Relatórios disponíveis
        <span class="text-500 font-normal ml-2" *ngIf="pagination.totalPages && pagination.totalPages > 1">
          (Página {{ pagination.pageNumber }} de {{ pagination.totalPages }})
        </span>
      </span>
    </div>
    <article *ngIf="appliedFilters.length > 0">
      <p>Filtros Aplicados</p>
      <div class="filter">
        <span *ngFor="let filter of appliedFilters">
          {{ filter.label }}: {{ filter.value }}
        </span>
      </div>
    </article>
  </div>

  <app-table
    class="w-100"
    *ngIf="totalDocumentos > 0"
    [pagination]="pagination"
    [columns]="columns"
    [actions]="actions"
    (pageChange)="onPageChange($event)">
  </app-table>

  <div class="no-data w-full" *ngIf="totalDocumentos === 0 && !carregando">
    <app-data-void
      titulo="Nenhum relatório encontrado"
      descricao="Ajuste os filtros de pesquisa para visualizar os relatórios oficiais disponíveis.">
    </app-data-void>
  </div>
</div>

<p-toast />

<!-- Diálogo Modal de Filtros de Documentos e Relatórios -->
<p-dialog
  header="Filtros de Documentos e Candidaturas"
  [draggable]="false"
  [modal]="true"
  [(visible)]="showModalFiltros"
  [style]="{ width: '44rem' }"
  [closable]="true">

  <form [formGroup]="formFiltros" class="SetBorder">
    <div class="p-fluid grid">
      <!-- Tipo de Relatório -->
      <div class="field col-12 d-flex flex-column mb-3">
        <label for="titulo" class="fw-semibold mb-1">Tipo de Relatório</label>
        <p-select
          [filter]="true"
          [showClear]="false"
          appendTo="body"
          id="titulo"
          formControlName="titulo"
          [options]="titlleOptions"
          optionLabel="label"
          optionValue="value"
          placeholder="Selecione o tipo de relatório"
          class="w-full">
        </p-select>
        <small
          class="p-error text-danger mt-1"
          *ngIf="formFiltros.get('titulo')?.invalid && formFiltros.get('titulo')?.touched">
          O tipo de relatório é obrigatório.
        </small>
      </div>

      <!-- Pesquisa por Título ou Palavra-chave -->
      <div class="field col-12 d-flex flex-column mb-3">
        <label for="pesquisa" class="fw-semibold mb-1">Pesquisa de Documento</label>
        <input
          pInputText
          id="pesquisa"
          type="text"
          formControlName="pesquisa"
          placeholder="Digite o título do documento ou palavra-chave..."
          class="w-full" />
      </div>

      <!-- Público-Alvo -->
      <div class="field col-6 d-flex flex-column mb-3">
        <label for="tipoPublico" class="fw-semibold mb-1">Público-Alvo</label>
        <p-select
          id="tipoPublico"
          appendTo="body"
          formControlName="tipoPublico"
          [options]="tipoPublicoOptions"
          optionLabel="label"
          optionValue="value"
          placeholder="Selecione o público"
          class="w-full">
        </p-select>
      </div>

      <!-- Formato do Arquivo -->
      <div class="field col-6 d-flex flex-column mb-3">
        <label for="formato" class="fw-semibold mb-1">Formato do Ficheiro</label>
        <p-select
          id="formato"
          appendTo="body"
          formControlName="formato"
          [options]="formatoOptions"
          optionLabel="label"
          optionValue="value"
          placeholder="Selecione o formato"
          class="w-full">
        </p-select>
      </div>

      <!-- Concurso Público (DRH) -->
      <div class="field col-6 d-flex flex-column mb-3">
        <label for="concursoId" class="fw-semibold mb-1">Concurso</label>
        <p-select
          id="concursoId"
          appendTo="body"
          [filter]="true"
          [showClear]="true"
          formControlName="concursoId"
          [options]="concursosList"
          optionLabel="label"
          optionValue="value"
          placeholder="Selecione o concurso"
          class="w-full">
        </p-select>
      </div>

      <!-- Oferta / Vaga do Concurso -->
      <div class="field col-6 d-flex flex-column mb-3">
        <label for="ofertaId" class="fw-semibold mb-1">Oferta do Concurso</label>
        <p-select
          id="ofertaId"
          appendTo="body"
          [filter]="true"
          [showClear]="true"
          formControlName="ofertaId"
          [options]="ofertasList"
          optionLabel="label"
          optionValue="value"
          [placeholder]="aCarregarOfertas ? 'A carregar ofertas...' : (formFiltros.get('concursoId')?.value ? 'Selecione a oferta' : 'Primeiro selecione um concurso')"
          class="w-full">
        </p-select>
      </div>

      <!-- Vaga Geral da Bolsa -->
      <div class="field col-12 d-flex flex-column mb-3">
        <label for="vagaId" class="fw-semibold mb-1">Vaga / Oportunidade do Sector</label>
        <p-select
          id="vagaId"
          appendTo="body"
          [filter]="true"
          [showClear]="true"
          formControlName="vagaId"
          [options]="vagasList"
          optionLabel="label"
          optionValue="value"
          placeholder="Selecione a vaga do sector"
          class="w-full">
        </p-select>
      </div>

      <!-- Período de Datas -->
      <div class="field col-6 d-flex flex-column mb-2">
        <label for="dataInicio" class="fw-semibold mb-1">Data Início</label>
        <p-datepicker
          id="dataInicio"
          appendTo="body"
          formControlName="dataInicio"
          dateFormat="dd/mm/yy"
          placeholder="dd/mm/aaaa"
          [showIcon]="true"
          class="w-full">
        </p-datepicker>
      </div>

      <div class="field col-6 d-flex flex-column mb-2">
        <label for="dataFim" class="fw-semibold mb-1">Data Fim</label>
        <p-datepicker
          id="dataFim"
          appendTo="body"
          formControlName="dataFim"
          dateFormat="dd/mm/yy"
          placeholder="dd/mm/aaaa"
          [showIcon]="true"
          class="w-full">
        </p-datepicker>
      </div>
    </div>
  </form>

  <ng-template pTemplate="footer">
    <div class="flex justify-content-between align-items-center w-full">
      <p-button
        label="Limpar Filtros"
        icon="pi pi-filter-slash"
        severity="secondary"
        [text]="true"
        (onClick)="limparFiltros()">
      </p-button>

      <div class="flex gap-2">
        <p-button
          label="Cancelar"
          icon="pi pi-times"
          severity="secondary"
          [outlined]="true"
          (onClick)="showModalFiltros = false">
        </p-button>

        <p-button
          label="Emitir Relatório"
          icon="pi pi-check"
          [loading]="carregando"
          (onClick)="aplicarFiltros()">
        </p-button>
      </div>
    </div>
  </ng-template>
</p-dialog>
